// Single source of truth for weight unit conversions.
// All factors expressed as: 1 unit = X kilograms.

export type WeightUnitKey =
  | "mg"
  | "g"
  | "tola"
  | "kg"
  | "lb"
  | "sher"
  | "mon"
  | "quintal"
  | "ton"
  | "usTon";

export interface WeightUnit {
  key: WeightUnitKey;
  en: string;
  bn: string;
  shortEn: string;
  shortBn: string;
  kg: number; // 1 unit = X kilograms
  note?: { en: string; bn: string };
}

export const WEIGHT_UNITS: WeightUnit[] = [
  { key: "mg",      en: "Milligram",       bn: "মিলিগ্রাম",  shortEn: "mg",  shortBn: "মিগ্রা", kg: 0.000001 },
  { key: "g",       en: "Gram",            bn: "গ্রাম",      shortEn: "g",   shortBn: "গ্রাম",  kg: 0.001 },
  { key: "tola",    en: "Tola",            bn: "তোলা",       shortEn: "tola",shortBn: "তোলা",   kg: 0.011664,
    note: { en: "BD jewelry unit (gold/silver) ≈ 11.664 g", bn: "বাংলাদেশের অলংকার একক (সোনা/রূপা) ≈ ১১.৬৬৪ গ্রাম" } },
  { key: "kg",      en: "Kilogram",        bn: "কিলোগ্রাম",  shortEn: "kg",  shortBn: "কেজি",   kg: 1 },
  { key: "lb",      en: "Pound",           bn: "পাউন্ড",     shortEn: "lb",  shortBn: "পাউন্ড", kg: 0.453592 },
  { key: "sher",    en: "Sher (Seer)",     bn: "সের",        shortEn: "sher",shortBn: "সের",    kg: 0.9331,
    note: { en: "Older BD trade unit ≈ 933 g (1/40 mon)", bn: "প্রাচীন বাজার একক ≈ ৯৩৩ গ্রাম (১/৪০ মন)" } },
  { key: "mon",     en: "Mon (Maund)",     bn: "মন",         shortEn: "mon", shortBn: "মন",     kg: 37.324,
    note: { en: "BD agricultural unit = 40 sher ≈ 37.324 kg", bn: "বাংলাদেশের কৃষি একক = ৪০ সের ≈ ৩৭.৩২৪ কেজি" } },
  { key: "quintal", en: "Quintal",         bn: "কুইন্টাল",   shortEn: "q",   shortBn: "কুইন্টাল", kg: 100 },
  { key: "ton",     en: "Metric Ton",      bn: "মেট্রিক টন", shortEn: "t",   shortBn: "টন",     kg: 1000 },
  { key: "usTon",   en: "US Ton (short)",  bn: "ইউএস টন",    shortEn: "ton", shortBn: "ইউএস টন",kg: 907.185 },
];

export const WEIGHT_UNIT_MAP: Record<WeightUnitKey, WeightUnit> =
  Object.fromEntries(WEIGHT_UNITS.map((u) => [u.key, u])) as Record<WeightUnitKey, WeightUnit>;

export const KG_PER_LB = 0.453592;
export const LB_PER_KG = 2.20462262185;
